import React, { Fragment } from 'react';
import axios from 'axios';
import Qs from 'qs'
import {
    Button, Card, CardBody
} from 'reactstrap';
import { clearSession } from '../../session';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactQuill from 'react-quill';


function insertPostImages() {
    let _this3 = this;
    let fileInput = this.container.querySelector('input.ql-insertImages[type=file]');
    if (fileInput == null) {
        fileInput = document.createElement('input');
        fileInput.setAttribute('type', 'file');
        fileInput.setAttribute('multiple', true);
        fileInput.setAttribute('accept', 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon');
        fileInput.classList.add('ql-image');
        fileInput.addEventListener('change', function () {
            if (fileInput.files != null && fileInput.files[0] != null) {
                for (let i = 0; i < fileInput.files.length; i++) {
                    let reader = new FileReader();
                    reader.onload = function (e) {
                        let image = new Image();
                        image.src = e.target.result;
                        image.onload = function () {
                            let height = this.height;
                            let width = this.width;
                            while (width >= 2000 || height >= 2000) {
                                height = height / 2;
                                width = width / 2;
                            }
                            let mainCanvas = document.createElement("canvas");
                            mainCanvas.width = width;
                            mainCanvas.height = height;
                            var ctx = mainCanvas.getContext("2d");
                            ctx.drawImage(image, 0, 0, mainCanvas.width, mainCanvas.height);
                            let image_64 = mainCanvas.toDataURL("image/jpeg");
                            let range = _this3.quill.getSelection(true);
                            _this3.quill.insertEmbed(range.index, 'image', { "src": image_64, "width": width, "height": height });
                            _this3.quill.setSelection(range.index + 1);
                            //_this3.quill.insertText(range.index + 1, 'n\n', {'display': 'none','img_width': width,'img_height':height});
                            _this3.quill.insertText(range.index + 1, '\n\n');
                            mainCanvas.remove();
                        };
                        if (i == fileInput.files.length - 1) {
                            fileInput.value = "";
                        }
                    };
                    reader.readAsDataURL(fileInput.files[i]);
                }
            }
        });
        this.container.appendChild(fileInput);
    }
    fileInput.click();
}


export default class InfoEditor extends React.Component {
    constructor(props) {
        super(props);
        this.myEditor = React.createRef();
        this.imageUploadClick = React.createRef();
        this.state = { option: props.option, info: null, item: null, lang_version: "EN" };
    }

    static getDerivedStateFromProps(props, state) {
        let new_state = {};
        let flag = false;
        if (props.option !== state.option) {
            new_state.option = props.option;
            flag = true;
        }

        if (flag) {
            return new_state;
        }
        return null;
    }


    componentDidMount() {
        let session = window.localStorage;
        let url;
        if (this.state.option === 30 || this.state.option === 31) {
            url = session.ch_action_url + "/action/get_home_rules_info";
        }
        else {
            url = session.ch_action_url + "/action/get_home_donation_info";
        }
        axios.post(url, Qs.stringify({
            token: session.ch_admin_token
        })).then(res => {
            if (res.data.status === -1) {
                clearSession();
            }
            else if (res.data.status === 0) {
                Swal.fire(
                    'Operation Failed!',
                    res.data.info,
                    'error');
            }
            else {
                let item = res.data.data;
                let info = "";
                if (this.state.option === 30) {
                    info = item.laws;
                }
                if (this.state.option === 31) {
                    info = item.regulations_en;
                }
                if (this.state.option === 50) {
                    info = item.introduction_en;
                }
                if (this.state.option === 51) {
                    info = item.letter_en;
                }
                this.setState({ item: item, info: info });
            }
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if ((this.state.option === 50 && (prevState.option === 30 || prevState.option === 31)) || (this.state.option === 51 && (prevState.option === 30 || prevState.option === 31))
            || (this.state.option === 30 && (prevState.option === 50 || prevState.option === 51)) || (this.state.option === 31 && (prevState.option === 50 || prevState.option === 51))) {
            let session = window.localStorage;
            let url;
            if (this.state.option === 30 || this.state.option === 31) {
                url = session.ch_action_url + "/action/get_home_rules_info";
            }
            else {
                url = session.ch_action_url + "/action/get_home_donation_info";
            }
            axios.post(url, Qs.stringify({
                token: session.ch_admin_token
            })).then(res => {
                if (res.data.status === -1) {
                    clearSession();
                }
                else if (res.data.status === 0) {
                    Swal.fire(
                        'Operation Failed!',
                        res.data.info,
                        'error');
                }
                else {
                    let item = res.data.data;
                    let info = "";
                    if (this.state.option === 30) {
                        info = item.laws;
                    }
                    if (this.state.option === 31) {
                        info = item.regulations_en;
                    }
                    if (this.state.option === 50) {
                        info = item.introduction_en;
                    }
                    if (this.state.option === 51) {
                        info = item.letter_en;
                    }
                    this.setState({ item: item, info: info });
                }
            });
        }
        else if(this.state.option!==prevState.option)
        {
                    let item = this.state.item;
                    let info = "";
                    if (this.state.option === 30) {
                        info = item.laws;
                    }
                    if (this.state.option === 31) {
                        info = item.regulations_en;
                    }
                    if (this.state.option === 50) {
                        info = item.introduction_en;
                    }
                    if (this.state.option === 51) {
                        info = item.letter_en;
                    }
                    this.setState({info: info });
        }
    }

    imagePreview(et) {
        et.preventDefault();
        let input = document.getElementById("item_image_input");
        let image_preview = document.getElementById("item_image");
        if (input.files && input.files[0]) {
            let FileSize = input.files[0].size / 1024 / 1024;
            let reader = new FileReader();
            reader.onload = function (e) {
                image_preview.src = e.target.result;
                //input.value = null;
                //modal.find('[data-target="face_image"]').prop('src', );
            };
            reader.readAsDataURL(input.files[0]);

        }
    }

    handUploadImageClick(e) {
        this.imageUploadClick.current.click();
    }

    updateInfo() {
        let session = window.localStorage;
        let url;
        if (this.state.option === 30 || this.state.option === 31) {
            url = session.ch_action_url + "/action/update_rules_info";
        }
        else {
            url = session.ch_action_url + "/action/update_donate_info";
        }

        let editor = this.myEditor.current.getEditor();
        let info = editor.root.innerHTML;
        axios.post(url, Qs.stringify({
            token: session.ch_admin_token,
            info: info,
            lang: this.state.lang_version,
            option: this.state.option
        })).then(res => {
            if (res.data.status === 0) {
                Swal.fire(
                    'Operation Failed!',
                    res.data.info,
                    'error');
            }
            else if (res.data.status === -1) {
                clearSession();
            }
            else {
                Swal.fire(
                    'Good Job!',
                    'The information has been updated',
                    'success');
                this.setState({info:info});
            }
        });
    }

    handleQuillChange = value => {
        //this.setState({ info: value });
    }

    handleChangeLang(e) {
        let value = e.target.value;
        let item = this.state.item;
        let info = "";
        if (this.state.option === 31 && value === "EN") {
            info = item.regulations_en;
        }
        else if (this.state.option === 31 && value === "CH") {
            info = item.regulations_ch;
        }
        else if (this.state.option === 50 && value === "EN") {
            info = item.introduction_en;
        }
        else if (this.state.option === 50 && value === "CH") {
            info = item.introduction_ch;
        }
        else if (this.state.option === 51 && value === "EN") {
            info = item.letter_en;
        }
        else if (this.state.option === 51 && value === "CH") {
            info = item.letter_ch;
        }
        this.setState({ item: item, info: info,lang_version:value });
    }



    render() {
        let modules = {
            toolbar: {
                container: "#my_editor_toolbar",
                handlers: {
                    insertImages: insertPostImages
                }
            }
        };
        let formats = ['link', 'image'];
        return (
            <Fragment>
                <div id="item_profile_post" className="p-1" style={{ width: "100%" }}>
                    <Card className="card-box mb-5 mt-1" style={{ maxWidth: "900px", margin: "auto" }}>
                        <div className="card-header bg-light">
                            <div className="card-header--title">
                                {this.state.option === 30 && <b>Update Law Information</b>}
                                {this.state.option === 31 && <b>Update Regulation</b>}
                                {this.state.option === 50 && <b>Update Donation Introduction</b>}
                                {this.state.option === 51 && <b>Update Donation Letter</b>}

                            </div>
                            {this.state.option !== 30 && <select id="post_lang_option" style={{ width: "100px", marginRight: "10px" }} defaultValue={"" + this.state.lang_version} onChange={(e) => this.handleChangeLang(e)}>
                                <option value="EN">EN</option>
                                <option value="CH">CH</option>
                            </select>}
                            <div className="card-header--actions d-flex">
                                <Button size="sm" color="first" onClick={e => this.updateInfo()}>Update</Button>
                            </div>
                        </div>
                        <CardBody className="pb-4">
                            <div className="new_post_content text-editor" style={{ minHeight: "500px" }}>
                                <ReactQuill ref={this.myEditor} className="my_post_editor" id="my_post_editor" theme="snow" value={this.state.info === null ? "" : this.state.info} onChange={this.handleQuillChange} placeholder="Example placeholder..." />
                            </div>
                        </CardBody>
                    </Card>
                </div>
            </Fragment>
        );
    }

}